export default __webpack_public_path__ + "static/media/personality-small-continue.359676a9.svg";